module.exports = __webpack_public_path__ + "img/wahlap_logo.3777fa5d.png";